import {INTERVIEW_TYPES, TRANSLATION, Yup, URL_FORMAT, MANAGE_ASSESSMENT} from '@/imports-files/pages/clients/jobs/automations'
export const INITIAL_VALUES = {
  test: {
    test_code: '',
    expires_in: ''
  }
}

export const duration = [
  {label: "15" , value: 15},
  {label: "30" , value: 30},
  {label: "45" , value: 45},
  {label: "60" , value: 60}
]

export const CONSTANTS = {
  errors:{
           minimum: 'Minimum $number',
           maximum: 'Maximum $number'
        }
}


export function validations(current_interview_type, validationData){
  if([INTERVIEW_TYPES.PHONE, INTERVIEW_TYPES.VIDEO, INTERVIEW_TYPES.FACE2FACE].includes(current_interview_type)){
    const phoneVideoFaceSchema = Yup.object().shape({
      place_id: Yup.string().nullable(true),
      default_location: Yup.string().when([],{
        is: () => { 
          return current_interview_type == INTERVIEW_TYPES.FACE2FACE
        },
        then: Yup.string().required(TRANSLATION('common:errors:required')).test("validLocation", "Invalid address, Please select from the dropdown", function (value) {
          return this.parent.place_id && this.parent.place_id.length > 0
        })
      }),
      job_meeting_details_attributes: Yup.array().of(
        Yup.object().shape({
          interview_type: Yup.string(), 
          _destroy: Yup.boolean(),
          duration: Yup.string().when("_destroy",{
            is: (_destroy) => { return !_destroy},
            then: Yup.string().required(TRANSLATION('common:errors:required'))
          }),
          // location_attributes: Yup.object().when(["interview_type", "_destroy"],{
          //   is: (interview_type, _destroy) => {
          //     return (!_destroy && (interview_type == INTERVIEW_TYPES.FACE2FACE))
          //   },
          //   then: Yup.object().shape({
          //     full_address: Yup.string().required(TRANSLATION('common:errors:required'))
          //   })
          // }),
          meeting_platform_attributes: Yup.object().when(["interview_type", "_destroy"],{
            is: (interview_type, _destroy) => {
              return (!_destroy && (interview_type == INTERVIEW_TYPES.VIDEO))},
            then: Yup.object().shape({
              integration_id: Yup.string().required(TRANSLATION('common:errors:required'))
            })
          }),
          member_emails: Yup.array().when("_destroy",{
            is: (_destroy) => { return !_destroy},
            then: Yup.array().min(1, TRANSLATION('common:errors:member_required'))
          }),
        })
      )
    })
    return phoneVideoFaceSchema;
  }
  else if(current_interview_type == INTERVIEW_TYPES.TECHTEST)
  {
    const techTestSchema = Yup.object({
        job_test_detail_attributes: Yup.object({
          test_id: Yup.string().required("Invalid test"),
          days_to_expire: Yup.string().required(TRANSLATION('common:errors:required')),
          test_type: Yup.string(),
          assessment: Yup.object()
          .shape({
            ...((validationData.type == 'Assessment') && (validationData.test_id.toString() == 'upload_new_test') ? {
              name: Yup.string().required(TRANSLATION('common:errors:required')),
              file_type: Yup.string().required(TRANSLATION('common:errors:required')),
              link: Yup.string().when("file_type", {
                is: (file_type) => file_type == 'link',
                then: Yup.string().matches(URL_FORMAT, 'Assessment link is invalid.'),
                otherwise: Yup.string().notRequired()
              }),
              filename: Yup.string().when("file_type", {
                is: (file_type) => file_type == 'file',
                then: Yup.string(),
                otherwise: Yup.string().notRequired()
              }),
              filesize: Yup.string().when("file_type", {
                is: (file_type) => file_type == 'file',
                then: Yup.string().test("is-greater", "Max. allowed file size 10 MB.", function(value) {
                  let currentFileSize = parseInt(value) || 0
                  return currentFileSize < MANAGE_ASSESSMENT.file_size
                }),
                otherwise: Yup.string().notRequired()
              }),
            } : {
            }),
          }),
        }),
      })
    return techTestSchema
  }
  else if(current_interview_type == INTERVIEW_TYPES.VIDEOQA)
  {
    const videQASchema = Yup.object({
                                language: Yup.string().required(TRANSLATION('common:errors:required')),
                                video_link: Yup.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, 'Please enter correct url').nullable(true),
                                questions_attributes: Yup.array(
                                                       Yup.object().shape({
                                                       question: Yup.string().max(300, 'Question must be at most 300 characters').required(TRANSLATION('common:errors:required')),
                                                      description: Yup.string().max(300, 'Description must be at most 300 characters'),
                                                      answer_time: Yup.number().required(TRANSLATION('common:errors:required')).min(30,CONSTANTS.errors.minimum.replace('$number', 30).replace('$data', 'secs')).max(120, CONSTANTS.errors.maximum.replace('$number', 120).replace('$data', 'secs')).nullable(true),
                                                      attempts: Yup.number().required(TRANSLATION('common:errors:required')).min(1, CONSTANTS.errors.minimum.replace('$number', 1).replace('$data', 'attempt')).max(3, CONSTANTS.errors.maximum.replace('$number', 3).replace('$data', 'attempts')).nullable(true)
                                                  })),
                                expires: Yup.number().required(TRANSLATION('common:errors:required')).min(1, CONSTANTS.errors.minimum.replace('$number', 1)).max(30, CONSTANTS.errors.maximum.replace('$number', 30)).nullable(true),
                          })
    return videQASchema
  }
  else {
    const interviewTypeSchema = Yup.object({
                                  interview_type_id: Yup.string().when("automation", {
                                    is: (automation) => automation,
                                    then: Yup.string().required(TRANSLATION('common:errors:required')).nullable(true),
                                    otherwise: Yup.string().notRequired().nullable(true)
                                  })
                                })
    return interviewTypeSchema;
  }
}
